/**
 * Global Diagnostics Utility
 * Exposes diagnostic functions to browser console for debugging
 */

import { UserActionLoggerDiagnostic } from './userActionLoggerDiagnostic';
import { ApiLoggerDiagnostic } from './apiLoggerDiagnostic';

// Expose diagnostic functions globally for browser console access
declare global {
  interface Window {
    getUserActionDiagnostics: () => any;
    getApiLoggerDiagnostics: () => any;
    exportUserActionReport: () => string;
    exportApiLoggerReport: () => string;
    clearAllDiagnostics: () => void;
  }
}

// Initialize global diagnostic functions
if (typeof window !== 'undefined') {
  window.getUserActionDiagnostics = () => {
    console.log('=== USER ACTION LOGGER DIAGNOSTICS ===');
    const report = UserActionLoggerDiagnostic.getDiagnosticReport();
    console.log(report);
    return report;
  };

  window.getApiLoggerDiagnostics = () => {
    console.log('=== API LOGGER DIAGNOSTICS ===');
    const report = ApiLoggerDiagnostic.getDiagnosticReport();
    console.log(report);
    return report;
  };

  window.exportUserActionReport = () => {
    console.log('=== USER ACTION LOGGER EXPORT FOR BACKEND TEAM ===');
    const report = UserActionLoggerDiagnostic.exportForBackendTeam();
    console.log(report);
    return report;
  };

  window.exportApiLoggerReport = () => {
    console.log('=== API LOGGER EXPORT FOR BACKEND TEAM ===');
    const report = ApiLoggerDiagnostic.exportForBackendTeam();
    console.log(report);
    return report;
  };

  window.clearAllDiagnostics = () => {
    UserActionLoggerDiagnostic.clearData();
    ApiLoggerDiagnostic.clearData();
    console.log('✅ All diagnostic data cleared');
  };

  console.log('🔧 Diagnostic functions available:');
  console.log('- getUserActionDiagnostics() - Get user action logger diagnostic report');
  console.log('- getApiLoggerDiagnostics() - Get API logger diagnostic report');
  console.log('- exportUserActionReport() - Export user action data for backend team');
  console.log('- exportApiLoggerReport() - Export API logger data for backend team');
  console.log('- clearAllDiagnostics() - Clear all captured diagnostic data');
}

export {};